import { Enrollment } from '../../../pure-js/types/GrooverTypes'

export const getDisplayNameFromEnrollment = (enrollmentUserId: string, enrollment: Enrollment): string | undefined => {
  if (enrollment.mainUser?.id === enrollmentUserId) {
    return enrollment.mainUser.name
  }
  if (enrollment.partnerUser?.id === enrollmentUserId) {
    return enrollment.partnerUser.name
  }
  return undefined
}
